import React, { createContext } from 'react';

export interface TabProps {
  title: string;
  label: string;
  placeholder?: string;
  callback?: (filterText?: string, summaryItemLabel?: string) => boolean;
}

export interface SummaryState {
  filterText: string;
  activeTab?: TabProps;
}

export const SummaryContext = createContext<SummaryState>({ filterText: '' });
export const SummarySetterContext = createContext<React.Dispatch<React.SetStateAction<SummaryState>>>(() => {});
